type RankMode = 'liked' | 'read' | 'rated';

interface RankingTabsProps {
  active: RankMode;
  onChange: (mode: RankMode) => void;
  genreFilter: string;
  onGenreChange: (genre: string) => void;
}

const GENRES = ['All', 'Psychological Horror', 'Supernatural', 'Cosmic Dread', 'Urban Legends', 'Slasher', 'Body Horror', 'Gothic'];

const tabs: { id: RankMode; label: string; icon: string; color: string }[] = [
  { id: 'liked',  label: 'Most Liked',  icon: 'ri-heart-fill',  color: 'text-red-500'    },
  { id: 'read',   label: 'Most Read',   icon: 'ri-eye-fill',    color: 'text-orange-400' },
  { id: 'rated',  label: 'Top Rated',   icon: 'ri-star-fill',   color: 'text-yellow-500' },
];

const RankingTabs = ({ active, onChange, genreFilter, onGenreChange }: RankingTabsProps) => (
  <div className="sticky top-16 z-30 bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-red-900/20">
    <div className="max-w-7xl mx-auto px-4">
      {/* Mode tabs */}
      <div className="flex items-center gap-1 pt-4 pb-0">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-['Crimson_Text'] transition-all duration-200 border-b-2 cursor-pointer whitespace-nowrap ${
              active === tab.id
                ? `border-red-600 text-white`
                : 'border-transparent text-gray-400 hover:text-gray-200'
            }`}
          >
            <div className={`w-4 h-4 flex items-center justify-center ${active === tab.id ? tab.color : ''}`}>
              <i className={tab.icon} />
            </div>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Genre filter pills */}
      <div className="flex items-center gap-2 py-3 overflow-x-auto scrollbar-hide">
        {GENRES.map((g) => (
          <button
            key={g}
            onClick={() => onGenreChange(g)}
            className={`px-3 py-1 rounded-full text-xs font-['Crimson_Text'] transition-all duration-200 cursor-pointer whitespace-nowrap border ${
              genreFilter === g
                ? 'bg-red-600 border-red-600 text-white'
                : 'bg-transparent border-red-900/30 text-gray-400 hover:border-red-600/50 hover:text-gray-200'
            }`}
          >
            {g}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export type { RankMode };
export default RankingTabs;
